// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3hOx5","buttons":"SendReceipts_buttons__1bkey","email":"SendReceipts_email__2VNr_","bookApptTitle":"SendReceipts_bookApptTitle__1UYdo"};